<template>
  <BriefStep :title="title" :tooltip="tooltip">
    <template v-slot:content>
      <div class="brief-form">
        <div
          class="form__input-wrapper form__input-wrapper--check"
          :class="{ error: $v.form.domainInfoSkip.$anyError }"
        >
          <input
            class=""
            id="domainInfoHas"
            type="radio"
            name="domainInfoSkip"
            :value="false"
            v-model="form.domainInfoSkip"
            @change="onDomainStatusChange"
          />
          <label for="domainInfoHas" class="form__label">
            Mam już zakupioną domenę
          </label>
        </div>
        <transition name="domain-input">
          <div
            v-if="form.domainInfoSkip === false"
            class="form__input-wrapper domain-input"
            :class="{ error: $v.form.domainInfo.$error }"
          >
            <label for="domain-info" class="form__label uk-hidden">Domena</label>
            <input
              class="form-input uk-width-1-1"
              id="domain-info"
              type="text"
              name="domain-info"
              placeholder="np. solveit.pl"
              :value="form.domainInfo"
              @input="onDomainInput"
              @blur="onDomainBlur"
            />
            <span class="form__error-message form__error-message--no-label">
              <template v-if="!$v.form.domainInfo.minLength && $v.form.domainInfo.$error">
                {{ validationMessage.minLength }}</template
              >
              <template v-if="!$v.form.domainInfo.required && $v.form.domainInfo.$error">
                {{ validationMessage.required }}</template
              >
            </span>
          </div>
        </transition>
        <div
          class="form__input-wrapper form__input-wrapper--check"
          :class="{ error: $v.form.domainInfoSkip.$anyError }"
        >
          <input
            class=""
            id="domainInfoSkip"
            type="radio"
            name="domainInfoSkip"
            :value="true"
            v-model="form.domainInfoSkip"
            @change="onDomainStatusChange"
          />
          <label for="domainInfoSkip" class="form__label">
            Nie kupiłem jeszcze domeny
          </label>
          <span class="form__error-message form__error-message--no-label">
            <template v-if="!$v.form.domainInfoSkip.required">
              {{ validationMessage.required }}</template
            >
          </span>
        </div>
      </div>
    </template>
  </BriefStep>
</template>
<script>
import { minLength, required } from 'vuelidate/lib/validators';

import stepValidation from '../../mixins/stepValidation';
import BriefStep from '../global/BriefStep.vue';

export default {
  name: 'DomainInfo',
  components: { BriefStep },
  mixins: [stepValidation],
  data: () => ({
    title:
      'Podaj nam swój adres. Spokojnie, nie potrzebujemy informacji o Twoim miejscu '
      + 'zamieszkania, a  o domenie (oczywiście, jeśli ją masz).',
    tooltip: 'Domena to, najprościej rzecz ujmując, adres strony internetowej.',
    form: {
      domainInfo: '',
      domainInfoSkip: null,
    },
  }),
  validations() {
    if (this.form.domainInfoSkip === false) {
      return {
        form: {
          domainInfoSkip: {
            required: value => value !== null && value !== undefined,
          },
          domainInfo: {
            required,
            minLength: minLength(3),
          },
        },
      };
    }

    return {
      form: {
        domainInfoSkip: {
          required: value => value !== null && value !== undefined,
        },
        domainInfo: {},
      },
    };
  },
  methods: {
    onDomainInput(event) {
      this.form.domainInfo = event.target.value;
      this.emitStep();
    },
    onDomainBlur() {
      if (this.form.domainInfoSkip !== false) {
        return;
      }

      this.$v.form.domainInfo.$touch();
      this.emitStep();
    },
    onDomainStatusChange() {
      if (this.form.domainInfoSkip === true) {
        this.form.domainInfo = '';
      }

      this.$v.form.domainInfo.$reset();
      this.delayTouch(this.$v.form.domainInfoSkip);
    },
  },
};
</script>
<style scoped lang="scss">
.domain-input {
  width: 100%;
}

.domain-input-enter-active,
.domain-input-leave-active {
  overflow: hidden;
  transition: max-height 0.4s ease, opacity 0.4s ease, transform 0.4s ease;
}

.domain-input-enter,
.domain-input-leave-to {
  max-height: 0;
  opacity: 0;
  transform: translateY(rem(-20px));
}

.domain-input-enter-to,
.domain-input-leave {
  max-height: rem(120px);
  opacity: 1;
  transform: translateY(0);
}
</style>
